// 消息提示默认参数
export const MESSAGE_PROMPT = {
  eventType: 3,
  entityType: 3,
  noticeType: 3,
  source: "int_futuresapp"
};
